/**
 * AUTO-GENERATED QUERY KEYS - DO NOT EDIT
 * Type-safe query key management
 */

export const queryKeys = {
  merchantprofile: {
    getMerchantProfile: (merchantId: string | number) => ['merchantprofile', 'getMerchantProfile', merchantId] as const,
    // Invalidation keys for mutations
    updateMerchantProfile: ['merchantprofile', 'updateMerchantProfile'] as const,
    all: ['merchantprofile'] as const,
  },

  merchantdashboard: {
    getDashboard: (merchantId: string | number) => ['merchantdashboard', 'getDashboard', merchantId] as const,
    all: ['merchantdashboard'] as const,
  },

  merchantcoupons: {
    listCoupons: (merchantId: string | number, query?: any) => ['merchantcoupons', 'listCoupons', merchantId, query] as const,
    getCoupon: (merchantId: string | number, couponId: string | number) => ['merchantcoupons', 'getCoupon', merchantId, couponId] as const,
    // Invalidation keys for mutations
    createCoupon: ['merchantcoupons', 'createCoupon'] as const,
    all: ['merchantcoupons'] as const,
  },

  merchantmembers: {
    listMembers: (merchantId: string | number, query?: any) => ['merchantmembers', 'listMembers', merchantId, query] as const,
    getMember: (merchantId: string | number, userId: string | number) => ['merchantmembers', 'getMember', merchantId, userId] as const,
    getPersonalMemberCard: (merchantId: string | number, userId: string | number) => ['merchantmembers', 'getPersonalMemberCard', merchantId, userId] as const,
    getCardBalances: (merchantId: string | number, cardId: string | number) => ['merchantmembers', 'getCardBalances', merchantId, cardId] as const,
    listMerchantGroups: (merchantId: string | number) => ['merchantmembers', 'listMerchantGroups', merchantId] as const,
    getMerchantGroup: (merchantId: string | number, cardId: string | number) => ['merchantmembers', 'getMerchantGroup', merchantId, cardId] as const,
    listMemberGroupCards: (merchantId: string | number, userId: string | number) => ['merchantmembers', 'listMemberGroupCards', merchantId, userId] as const,
    // Invalidation keys for mutations
    updateMemberCredits: ['merchantmembers', 'updateMemberCredits'] as const,
    createPersonalMemberCard: ['merchantmembers', 'createPersonalMemberCard'] as const,
    updatePersonalMemberCard: ['merchantmembers', 'updatePersonalMemberCard'] as const,
    createCardBalances: ['merchantmembers', 'createCardBalances'] as const,
    createCardBackground: ['merchantmembers', 'createCardBackground'] as const,
    removeCardBackground: ['merchantmembers', 'removeCardBackground'] as const,
    createMerchantGroup: ['merchantmembers', 'createMerchantGroup'] as const,
    updateMerchantGroup: ['merchantmembers', 'updateMerchantGroup'] as const,
    createMerchantGroupMemberAssignment: ['merchantmembers', 'createMerchantGroupMemberAssignment'] as const,
    removeMerchantGroupMember: ['merchantmembers', 'removeMerchantGroupMember'] as const,
    createMemberEnrollment: ['merchantmembers', 'createMemberEnrollment'] as const,
    all: ['merchantmembers'] as const,
  },

  merchantredemption: {
    listRedemptions: (merchantId: string | number, query?: any) => ['merchantredemption', 'listRedemptions', merchantId, query] as const,
    // Invalidation keys for mutations
    createRedemption: ['merchantredemption', 'createRedemption'] as const,
    checkCashierCode: ['merchantredemption', 'checkCashierCode'] as const,
    checkCouponCode: ['merchantredemption', 'checkCouponCode'] as const,
    all: ['merchantredemption'] as const,
  },

  merchantcredits: {
    listDeposits: (merchantId: string | number, query?: any) => ['merchantcredits', 'listDeposits', merchantId, query] as const,
    // Invalidation keys for mutations
    createDeposit: ['merchantcredits', 'createDeposit'] as const,
    all: ['merchantcredits'] as const,
  },

  merchanttransactions: {
    listTransactions: (merchantId: string | number, query?: any) => ['merchanttransactions', 'listTransactions', merchantId, query] as const,
    all: ['merchanttransactions'] as const,
  },

  customerprofile: {
    getUserMerchants: () => ['customerprofile', 'getUserMerchants'] as const,
    all: ['customerprofile'] as const,
  },
};